import React, { useState } from 'react'
import { get } from 'lodash'
import { useNavigate } from "react-router-dom"

export default ({bioData}) => {
  const navigate = useNavigate()

  const goToBio = () => {
    navigate(`/${bioData.category}/${bioData.slug}`)
  }

  return (
    <div className="w-full text-center cursor-pointer bio-thumb" onClick={goToBio}>
      <div className="mx-auto bg-cover bg-center w-[8rem] h-[8rem] md:w-[12rem] md:h-[12rem] rounded-[50%] mb-4" style={{backgroundImage: `url('${get(bioData, 'image.url')}')`}}></div>
      <div className="block font-semibold">{bioData.name}</div>
      <div className="text-xs md:text-sm font-extralight uppercase">
        <div className="bio-title">{bioData.title}</div>
        <div className="bio-cta hidden ">
          Learn more
          <span className="ml-1 material-symbols-rounded text-sm">
            arrow_forward_ios
          </span>
        </div>
      </div>

    </div>
  )
}